const VALIDATION_MESSAGES = {
  'customer_onlyOneOccupancyStatus': 'Please select only one option for the customer occupancy status.',
  'signature_required': 'A customer signature is required.',
  'clientInterview1Pretest_onlyOne': 'Please select only one option for this question',
  'clientInterview2Pretest_onlyOne': 'Please select only one option for this question',
  'clientInterview3Pretest_onlyOne': 'Please select only one option for this question',
  'clientInterview4Pretest_onlyOne': 'Please select only one option for this question',
  'clientInterview5Pretest_onlyOne': 'Please select only one option for this question',
  'clientInterview6Pretest_onlyOne': 'Please select only one option for this question',
} 

const useValidation = (control) => {
  const { getValues } = control;

  return {
    "isPropertyOwner": () => ({
      validate: () => {
        const occupancyStatuses = ["isPropertyOwner", "isLandlordPropertyAgent", "isTenant"];
        const count = occupancyStatuses.filter(occupancyStatus => !!getValues(occupancyStatus)).length;
        return (count === 1) || VALIDATION_MESSAGES['customer_onlyOneOccupancyStatus'];
      },
    }),
    "clientInterview1_today": () => ({
      validate: () => {
        const interviewAnswers = ['clientInterview1_today', 'clientInterview1_yesterday', 'clientInterview1_twoPlusDays', 'clientInterview1_NA']
        const count = interviewAnswers.filter(interviewAnswer => !!getValues(interviewAnswer)).length;
        return (count === 1) || VALIDATION_MESSAGES['clientInterview1Pretest_onlyOne']
      }
    }),
    "clientInterview2_yes": () => ({
      validate: () => {
        const interviewAnswers = ['clientInterview2_yes', 'clientInterview2_no', 'clientInterview2_NA']
        const count = interviewAnswers.filter(interviewAnswer => !!getValues(interviewAnswer)).length;
        return (count === 1) || VALIDATION_MESSAGES['clientInterview2Pretest_onlyOne']
      }
    }),
    "clientInterview3_today": () => ({
      validate: () => {
        const interviewAnswers = ['clientInterview3_today', 'clientInterview3_yesterday', 'clientInterview3_twoPlusDays', 'clientInterview3_NA']
        const count = interviewAnswers.filter(interviewAnswer => !!getValues(interviewAnswer)).length;
        return (count === 1) || VALIDATION_MESSAGES['clientInterview3Pretest_onlyOne']
      }
    }),
    "clientInterview4_yes": () => ({
      validate: () => {
        const interviewAnswers = ['clientInterview4_yes', 'clientInterview4_no', 'clientInterview4_NA']
        const count = interviewAnswers.filter(interviewAnswer => !!getValues(interviewAnswer)).length;
        return (count === 1) || VALIDATION_MESSAGES['clientInterview4Pretest_onlyOne']
      }
    }),
    "clientInterview5_yes": () => ({
      validate: () => {
        const interviewAnswers = ['clientInterview5_yes', 'clientInterview5_no', 'clientInterview5_NA']
        const count = interviewAnswers.filter(interviewAnswer => !!getValues(interviewAnswer)).length;
        return (count === 1) || VALIDATION_MESSAGES['clientInterview5Pretest_onlyOne']
      }
    }),
    "clientInterview6_yes": () => ({
      validate: () => {
        const interviewAnswers = ['clientInterview6_yes', 'clientInterview6_no', 'clientInterview6_NA']
        const count = interviewAnswers.filter(interviewAnswer => !!getValues(interviewAnswer)).length;
        return (count === 1) || VALIDATION_MESSAGES['clientInterview6Pretest_onlyOne']
      }
    }),
    "signature": () => ({
      validate: (signature) => (!!signature) || VALIDATION_MESSAGES['signature_required']
    })
  };
};

export default useValidation;
